import React, { useRef } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';

// Child component — DO NOT export this directly
const PropertySectionv = ({ title, properties = [] }) => {
  const scrollRef = useRef(null);

  const handleScroll = (direction) => {
    const { current } = scrollRef;
    if (!current) return;

    const scrollAmount = direction === 'left' ? -320 : 320;
    current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  return (
    <div className="location-group">
       <div className="header-content">
        <h2 className="section-title">Discover Your Dream Home</h2>
        <p className="section-subtitle">Explore premium homes across top localities in Gurgaon</p>
      </div>
      <h2 className="location-title">{title}</h2>

      <div className="scroll-wrapper">
        <button
          className="scroll-arrow left"
          onClick={() => handleScroll('left')}
        >
          <ChevronLeft size={24} />
        </button>

        <div className="grid-container" ref={scrollRef}>
          {properties.map((prop, idx) => (
            <div key={idx} className="property-card">
              <div className="image-wrapper">
                <img src={prop.image} alt={prop.name} />
              </div>

              <div className="property-info">
                <h3>{prop.name}</h3>
                <p className="sector">{prop.location}</p>
                <p className="bhk">{prop.bhk} BHK</p>
                <p className="price">Starting From Rs. {prop.price}</p>
              </div>
            </div>
          ))}
        </div>

        <button
          className="scroll-arrow right"
          onClick={() => handleScroll('right')}
        >
          <ChevronRight size={24} />
        </button>
      </div>
      {/* <button className="blog-section-chevron-button">View More</button> */}
    </div>
  );
};

// Parent component — THIS is what should be rendered
const PropertyGrid = () => {
  const dwarkaProps = [
    {
      name: "Sobha City",
      location: "Sector 108, Gurugram Expressway",
      bhk: "2/3/4",
      price: "2.82 Cr.",
      image: "https://100billion.in/client_images/4.png"
    },
    {
      name: "Hero Homes",
      location: "Sector 104, Dwarka Expressway",
      bhk: "2/3",
      price: "1.4 Cr.",
      image: "https://100billion.in/client_images/2.png"
    },
    {
      name: "BPTP Amaario",
      location: "Sector 37 D, Dwarka Expressway",
      bhk: "4",
      price: "5.72 Cr.",
      image: "https://100billion.in/client_images/3.png"
    },
    {
      name: "Smartworld One DXP",
      location: "Sector 113, Dwarka Expressway",
      bhk: "2/3/4",
      price: "3.5 Cr.",
      image: "https://100billion.in/client_images/1.png"
    },
    {
      name: "Adore Selection",
      location: "Sector 77, Gurgaon",
      bhk: "3/4",
      price: "2.5 Cr.",
      image: "https://100billion.in/client_images/4.png"
    }
  ];

  return (
    <div className="property-discovery-container">
      <PropertySectionv
        title="Properties in Gurugram Expressway"
        properties={dwarkaProps}
      />
      <PropertySectionv
        title="Properties in Noida"
        properties={dwarkaProps}
      />
    </div>
  );
};

export default PropertyGrid;
